import { FC } from 'react'
import Page from '@/client/submodules/Page'
import { Featured } from './Featured'
import { List } from './List'
import { FAQProps } from './types'

export const FAQ: FC<FAQProps> = ({ seo, content, header, footer }) => {
  const { breadcrumb, title, subtitle, description, search_input_label, list } = content

  return (
    <Page seo={seo} header={header} footer={footer}>
      <Featured breadcrumb={breadcrumb} title={title} subtitle={subtitle} description={description} />
      <List search_input_label={search_input_label} list={list} />
    </Page>
  )
}
